import React, { useEffect, useState } from "react";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateToString, formatToUsDateFromUTCNew } from "../utils/DateHelper";
import { isValid } from "date-fns";
import { Link } from "@mui/material";
import { isSameDay } from "date-fns";

interface props {
  date: string,
  initialDate: string,
  setDate: (date: string) => void,
  label?: string,
  fontSize?: number,
  background?: string,
  width?: string,
  height?: string,
  marginTop?: string,
  maxDate?: string,
  disabled?: boolean,
}
const DatePickerWithLabel: React.FC<props> = ({date, initialDate, label, setDate, fontSize, background, width, height, marginTop, maxDate, disabled}) => {
    const [showDatePicker, setShowDatePicker] = useState(false);
    const handleDateChange = (date) => {
      if (date instanceof Date && isValid(date)) {
        setDate(dateToString(date));
        setShowDatePicker(false);
      }
    }
    const renderDay = (day, selectedDate, isInCurrentMonth, dayComponent) => {
      const today = new Date();
      const isToday = isSameDay(day, today) && !isSameDay(selectedDate, today);
  
      return React.cloneElement(dayComponent, {
        style: {
          color: isToday ? '#ff890a' : undefined, // Set color to orange if today
        },
      });
    };
    return (  
        <div className={`${label? "date-container" : "date-container-without-label"}`}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              renderDay={renderDay}
              label={label ? label: undefined}
              id="date-picker-inline"
              value={date ?  formatToUsDateFromUTCNew(date) :  null}
              open={showDatePicker}
              onOpen={() => !disabled && setShowDatePicker(true)}
              onClose={() => setShowDatePicker(false)}
              onChange={handleDateChange}
              disabled={disabled}
              className="textInput plainLabel"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              maxDate={maxDate ? new Date(maxDate) : undefined}
              InputProps={{
                disableUnderline: true,
                inputProps: {
                  placeholder: "mm/dd/yyyy",
                  style: {
                    fontSize: fontSize? fontSize : 12,
                    color: "#868382",
                    opacity: 1,
                    fontWeight: 500,
                    marginTop: marginTop ? marginTop:'0'
                  },
                },
              }}
              InputLabelProps={{
                shrink: label? true: false,
                style: {
                  color: "#868382",
                  fontSize: fontSize? fontSize : 12,
                  fontWeight: 500,
                  margin: "10px 0 0 10px",
                },
              }}
              style={{
                margin: 0,
                backgroundColor: `${background || "rgb(239, 233, 231)"}`,
                height: height ? height : "42.5px",
                width: `${width ? width: "100%"}`
              }}
              ToolbarComponent={() => (
                <Link
                  sx={{
                    fontSize: "14px",
                    order: 1,
                    textAlign: "right",
                    padding: "15px",
                    paddingTop: "0"
                  }}
                  onClick={() => {
                    setDate("");
                    setShowDatePicker(false);
                  }}
                >
                  Clear
                </Link>
              )}
            />
          </MuiPickersUtilsProvider>
        </div>
    )
}

export default DatePickerWithLabel;